import { EventIds } from '../../constants';
import { PaginatedUserCollectionsQuery } from './userCollection.gql';

export const QueryConfig = {
    query: PaginatedUserCollectionsQuery,
    pathToItems: 'paginatedUserCollections',
    pathToTotalItems: 'totalRecords',
    failureEvent: {
        eventId: EventIds.RequestCollectionSamplesFailed,
        message: 'Failed to get collection samples',
    },
};
